import React, { useState, useEffect, createContext } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import SearchHistory from './pages/SearchHistory';
import Bookmarks from './pages/Bookmarks';
import AdminPanel from './pages/AdminPanel';
import AdminInit from './pages/AdminInit';
import Analytics from './pages/Analytics';
import WhatsNew from './pages/WhatsNew';
import PaymentSuccess from './pages/PaymentSuccess';
import DebugAuth from './pages/DebugAuth';
import AuthDiagnostic from './pages/AuthDiagnostic';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FAQ from './pages/FAQ';
import { Toaster } from './components/ui/sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AuthContext = createContext(null);

const App = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await axios.get(`${API}/auth/check`, {
        withCredentials: true
      });
      setUser(response.data.user);
      setHasAccess(response.data.has_access);
    } catch (error) {
      console.log('Not authenticated');
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
      setUser(null);
      setHasAccess(false);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, setUser, hasAccess, setHasAccess, logout, checkAuth }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={user ? <Navigate to="/dashboard" /> : <LandingPage />} />
          <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/" />} />
          <Route path="/history" element={user ? <SearchHistory /> : <Navigate to="/" />} />
          <Route path="/bookmarks" element={user ? <Bookmarks /> : <Navigate to="/" />} />
          <Route path="/admin" element={user && user.role === 'admin' ? <AdminPanel /> : <Navigate to="/" />} />
          <Route path="/admin/analytics" element={user && user.role === 'admin' ? <Analytics /> : <Navigate to="/" />} />
          <Route path="/admin/init" element={<AdminInit />} />
          <Route path="/whats-new" element={<WhatsNew />} />
          <Route path="/debug" element={user ? <DebugAuth /> : <Navigate to="/" />} />
          <Route path="/auth-diagnostic" element={<AuthDiagnostic />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/payment-success" element={user ? <PaymentSuccess /> : <Navigate to="/" />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthContext.Provider>
  );
};

export default App;
